export default __webpack_public_path__ + "static/media/step-text.0bd882ec.svg";